import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Header from '../Header';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { Control, LocalForm } from 'react-redux-form';
import { Helmet } from 'react-helmet';
import Footer from '../Footer';
import UserTable from './table';
import {Link} from "react-router-dom";
import './styles.css';

const messages = defineMessages({
  htmlHeader: {
    id: 'preview.html.header',
    description:
      'The title of the page that appears in the html header of the page.',
    defaultMessage: 'Preview'
  },
  headerTitle: {
    id: 'data.factory',
    description: 'Page Header Title',
    defaultMessage: 'MY DATA FACTORY'
  },
  headerSubTitle: {
    id: 'data.factory.subtitle',
    description: 'Page Header Subtitle',
    defaultMessage: 'MY data factory management home'
  },
  searchFiles: {
    id: 'preview.search.files',
    description: 'search files',
    defaultMessage: 'Search Files'
  },
  alertTitle: {
    id: 'preview.alert.title',
    description: 'Preview API alert title',
    defaultMessage: 'Loading Project Files Failed'
  }
});

class Datafactorymanagement extends Component {

  componentWillMount() {
    this.setState({customer:sessionStorage.getItem('firstimeselectedcus')});
  }
  componentDidMount(){
    
    //this.props.getCustomerdfList("-1");
    console.log(this.props.role);
    console.log(this.props.customerdfList.length);
    // if(true){
     if(this.props.role.includes('TRANSLATION_LEAD') || this.props.role.includes('DATA_ENGINEER')){
      this.props.getCustomers();   // did in pre snow path
      //alert(sessionStorage.getItem('firstimeselectedcus'));
     // this.props.getusersList(this.props.username);
     this.setState({customer:sessionStorage.getItem('firstimeselectedcus')});
     //alert(sessionStorage.getItem('firstimeselectedcus'));
     this.props.getCustomerdfList(sessionStorage.getItem('firstimeselectedcus'));
     console.log(this.props.username);
     console.log(this.props.customerid);
    }else{
               console.log(this.props.username);
               console.log(this.props.customerid);

               this.setState({customer:this.props.customerid});
          if( this.props.role.includes('PROFESSIONAL_SERVICE')){
            this.props.getCustomerdfList(this.props.customerid)
          }

          if(! this.props.role.includes('PROFESSIONAL_SERVICE')){
            this.props.getCustomerdfList(this.props.customerid)
          }




      //this.props.getusersList(this.props.username);
      // const type = this.props.userType === "standard" ? "Assessment" : "FreeAssessment";
      // this.setState({repo: this.props.match.params.prj});
      // this.props.getinfobyreponameforaccessment(this.props.match.params.prj,this.props.customerid,type,this.updateSrcTar);
      // this.props.gitlabProjects(jobType,this.props.customerid);
    }

  }

  constructor(props) {
    super(props);
    const { intl } = this.props;
    this.state = {
      showInvite: false,
      showInviteSent: false,
      firstname: "",
      lastname: "",
      email: "",
      phone: "",
      role: "",
      delUser: "",
      delEmail: "",
      status: "",
      reponame:"",
      dfid:"",
      customer: "",
      companyname:'',
      owner:"",
      selectedjdbclength:[],
      disablepr:true
      //customerdfList:[],
    };
  }
  showInviteTrue = () => {
    this.setState({ showInvite: true });
    messages.headerTitle = {
      id: 'user.invitation',
      description: 'Page Header Title',
      defaultMessage: 'User Invitation'
    };
  };
  showInviteFalse = () => {
    this.setState({ showInvite: false });
    messages.headerTitle = {
      id: 'user.management',
      description: 'Page Header Title',
      defaultMessage: 'User Management'
    };
  };

  sendInvite = () => {
    this.props.inviteUser(
      this.state.firstname,
      this.state.lastname,
      this.state.email,
      this.state.phone,
      this.props.username,
      this.state.role,
      this.invitedsent
    );
  }

  invitedsent = ()=>{
    this.setState({showInviteSent : true});
    messages.headerTitle = {
      id: 'user.invitation',
      description: 'Page Header Title',
      defaultMessage: 'Success'
    };
  }

  selectItem = (value)=>{
    console.log(value);
    this.setState({reponame:value.reponame,
                    dfid:value.dfid,
                    owner:value.owner,
                    selectedjdbclength:value.jdbclistcopyy.length,
                 delUser: value.username,status: value.status,delEmail: value.email})

    this.props.docheckddlexist(this.state.customer, 
      value.reponame,'DDLPage',this.disableproject);
      
  }

  disableproject= (e)=>{
    this.setState(e);

  }

  selectCus = (e)=>{
    //this.props.resetStagingPrjList();
    const jobType = this.props.userType === "standard" ? "Assessment" : "FreeAssessment";
    this.setState({customer : e.target.value});
   // this.props.customersPrjList(jobType,e.target.value);
   console.log({customer : e.target.value});
   //this.props.getusersList("ayu03");//(this.props.username);
   this.props.getusersList(this.props.username);
  }

  selectDfs   = (e, name)=>{
    this.setState({ dfid:""});
    if(e.target.value==""){
      this.setState({customer :""}); 
      this.props.getCustomerdfList("test");
      return;
    }

  
    this.props.getCustomerdfList("test");
    this.setState({ dfid:""});
    sessionStorage.setItem('firstimeselectedcus',e.target.value);
    console.log(e.target.value);
    console.log(name['company_name']);
    this.setState({customer : e.target.value});  //, dfid : ""});

   console.log({customer : e.target.value});

   this.props.customersList.map(item => {
      if (item.customer_id== e.target.value){
               this.setState({companyname:item['company_name']});
      }

    });

   //this.props.getCustomerdfList(e.target.value,  this.setState({ dfs: [] }));
   this.props.getCustomerdfList(e.target.value);
  }


  render() {
    return (
      <div className="preview page">
        <Helmet>
          <title>
            {this.props.intl.formatMessage(messages.htmlHeader)} - FUSE
          </title>
        </Helmet>
        <Header
          title={this.props.intl.formatMessage(messages.headerTitle)}
          subtitle={this.props.intl.formatMessage(messages.headerSubTitle)}
          icon="preview"
          locale={this.props.locale}
          status = {this.props.status}
        />

        <div className="main">
          {this.state.showInvite &&(
            <div
              className="panel"
              style={{
                width: '90%',
                padding: '20px',
                boxSizing: 'content-box',
                marginTop: '15px',
                display: 'block',
                alignContent: 'center',
                marginLeft: 'auto',
                marginRight: 'auto'
              }}
            >
              {this.state.showInviteSent &&(
                <div>
                  <label
                    style={{
                      width: '90%',
                      fontSize: '16px',
                      textTransform: 'none',
                      lineHeight: '150%'
                    }}
                  >
                    An invitation with temporary password has been sent to the user.
                  </label>
                  <br />
                  &nbsp;
                  <br />
                  &nbsp;
                  <div className="button-container" style={{ textAlign: 'center' }}>
                    <button
                      className="button"
                      styel={{ padding: 20 }}
                      type="button"
                      onClick={() => window.location.reload()}
                    >
                      <FormattedMessage id="nav.ok" defaultMessage="OK" />
                    </button>
                  </div>
                </div>
              )}

              {!this.state.showInviteSent &&(
                <LocalForm
                  className="form"
                  model="user"
                  onSubmit={this.sendInvite}
                >
                  <fieldset>
                    <label style={{ textTransform: 'capitalize' }}>
                      <FormattedMessage
                        id="user.firstname.title"
                        defaultMessage="First Name: "
                      />
                    </label>
                    <Control.text
                      model="user.firstname"
                      value={this.state.firstname}
                      autoFocus
                      onChange={event=>{this.setState({firstname: event.target.value})}}
                    />
                  </fieldset>

                  <fieldset>
                    <label style={{ textTransform: 'capitalize' }}>
                      <FormattedMessage
                        id="user.lastname.title"
                        defaultMessage="Last Name: "
                      />
                    </label>
                    <Control.text
                      model="user.lastname"
                      value={this.state.lastname}
                      autoFocus
                      onChange={event=>{this.setState({lastname: event.target.value})}}
                    />
                  </fieldset>

                  <fieldset>
                    <label style={{ textTransform: 'capitalize' }}>
                      <FormattedMessage
                        id="assessment.request.translation.Email.name"
                        defaultMessage="Email: "
                      />
                    </label>

                    <Control.text
                      model="user.email"
                      value={this.state.email}
                      type="email"
                      autoFocus
                      required
                      onChange={event=>{this.setState({email: event.target.value})}}
                    />
                  </fieldset>

                  <fieldset>
                    <label style={{ textTransform: 'capitalize' }}>
                      <FormattedMessage
                        id="telephone.label.name"
                        defaultMessage="Telephone"
                      />
                    </label>

                    <Control.text
                      model="user.phone"
                      value={this.state.phone}
                      autoFocus
                      onChange={event=>{this.setState({phone: event.target.value})}}
                    />
                  </fieldset>

                  <fieldset>
                    <label style={{ textTransform: 'capitalize' }}>
                      <FormattedMessage
                        id="projects.user.role"
                        defaultMessage="Role: "
                      />
                    </label>
                    <Control.select
                      model="user.role"
                      defaultValue={this.state.role}
                      autoFocus
                      required
                      onChange={event=>{this.setState({role: event.target.value})}}
                    >
                      <option value="">Please select one role</option>
                      <option value="PROFESSIONAL_SERVICE">Analysis and Translation Engineer</option>
                    </Control.select>
                  </fieldset>

                  <div className="button-container" style={{ textAlign: 'center' }}>
                    <button
                      className="button"
                      type="submit"
                      onClick={()=>{this.showInviteFalse();this.props.getusersList(this.props.username);} }
                      style={{ marginRight: '40px' }}
                    >
                      <FormattedMessage
                        id="run-assessment.back.button.name"
                        textTransform="capitalize"
                        defaultMessage="Back"
                      />
                    </button>

                    <button
                      className="button"
                      type="submit"
                    >
                      <FormattedMessage
                        id="submit.button.name"
                        defaultMessage="Submit"
                      />
                    </button>
                  </div>
                </LocalForm>
              )}

            </div>

          )}


         {/* {!this.state.showInvite && (<div */}

          { (this.props.role.includes('TRANSLATION_LEAD')||this.props.role.includes('DATA_ENGINEER')) && (<div
              className="panel2"
              style={{
                width: '90%',
                padding: '20px,40px,0,40px',
                boxSizing: 'content-box',
                marginTop: '15px',
                display: 'block',
                alignContent: 'center',
                marginLeft: 'auto',
                marginRight: 'auto',
                borderstyle:'none !important',
                height: '234px',
                background: 'white',
                marginTop: '25px',
              }}
            >
             <LocalForm
                  className="form"
                  style={{
                    marginLeft:'50px',

                }}
                  //model="user"
                 // onSubmit={this.sendInvite}
                >
                    <fieldset><br/>
                    <label style={{ textTransform: 'capitalize',margintop:'30px' }}>
                      <FormattedMessage
                        id="customerorg.name"
                        defaultMessage="customer organization name"
                      />
                    </label>
                    <Control.select
                     style={{width:'400px'}}
                      //model=".dfactory"
                      model=".customer"
                      //defaultValue={this.state.customer}
                      value={this.state.customer}
                      autoFocus
                      required
                      // onChange={event=>{this.setState({customer: event.target.value})}}
                     // onChange={this.selectDfs}
                     onChange={(event,item)=>{this.selectDfs(event,item)}}
                    >
                     {/* {(this.state.customer === "" || this.state.customer === null) && <option value="">Please select organization name</option>} */}
                     <option value="">Please select organization name</option>
                            {this.props.customersList.map(item => (
                              <option key={item["customer_id"]} value={item["customer_id"]}>
                                {item["company_name"]}
                              </option>
                            ))}

                    </Control.select>
                  </fieldset>
               </LocalForm>
            </div> )
            }


          {!this.state.showInvite && (
            <div
              className="panel2"
              style={{
                width: '90%',
                height: '100%',
                padding: '20px',
                boxSizing: 'content-box',
                // marginTop: '15px',
                display: 'block',
                alignContent: 'center',
                marginLeft: 'auto',
                marginRight: 'auto',
                margintop:'none',
                borderTop:'none',
                margintop: '-152px !important',
                background:'white'
              }}
            >

            {/* <div
              className="panel2"
              style={{
                width: '71%',
                padding: '40px,40px,0,40px',
                boxSizing: 'content-box',
                marginTop: '15px',
                display: 'block',
                alignContent: 'center',
                marginLeft: 'auto',
                marginRight: 'auto',
                borderstyle:'none !important'
                // background:'white'
              }}
            >
             <LocalForm
                  className="form"
                  //model="user"
                 // onSubmit={this.sendInvite}
                >
                    <fieldset>
                    <label style={{ textTransform: 'capitalize' }}>
                      <FormattedMessage
                        id="customerorg.name"
                        defaultMessage="customer organization name"
                      />
                    </label>
                    <Control.select
                      model=".dfactory"
                      defaultValue={this.state.dfactory}
                      autoFocus
                      required
                      onChange={event=>{this.setState({dfactory: event.target.value})}}
                    >
                      <option value="">Please select customer organization name</option>
                      <option value="Test">Test</option>
                    </Control.select>
                  </fieldset>
               </LocalForm>
            </div>
            */}
              {/* <UserTable style={{}} data={this.props.usersList} selectItem={this.selectItem}  username={this.props.username}/> */}
              
           {(this.props.customerdfList.length!=0) &&
              <UserTable style={{fontSize:'11px'}} data={this.props.customerdfList} selectItem={this.selectItem}  username={this.props.username} userRole={this.props.role}/>
             } 
              <div
                className="button-container"
                style={{ textAlign: 'center' }}
              >
               {/* <button
                  className="button"
                  style={{ marginRight: '11PX' }}
                  type="button"
                  onClick={() => this.props.clickBackHandler()}
                >
                  <FormattedMessage
                    id="run-assessment.back.button.name"
                    defaultMessage="Back"
                  />
                </button>*/}
                {/* <button
                  className="button"
                  style={{ marginRight: '11PX' }}
                  type="button"
                  onClick={this.showInviteTrue}
                >
                  <FormattedMessage
                    id="management.invite"
                    defaultMessage="INVITE USER"
                  />
                </button> */}
              <Link style={((!this.props.role.includes('TRANSLATION_LEAD')&& !this.props.role.includes('PROFESSIONAL_SERVICE')
                  && !this.props.role.includes('DATA_ENGINEER'))
                  ||(this.props.role.includes('TRANSLATION_LEAD')
                  && (this.state.customer=="" || this.state.customer==null )))?{ pointerEvents: 'none' }:{}} 
               to={((!this.props.role.includes('TRANSLATION_LEAD')&& !this.props.role.includes('PROFESSIONAL_SERVICE')
                  && !this.props.role.includes('DATA_ENGINEER'))
                  ||(this.props.role.includes('TRANSLATION_LEAD')
                  && (this.state.customer=="" || this.state.customer==null )))?`#`:`/en-CA/createdatafactory/${this.state.customer}`} >
                <button  disabled={(!this.props.role.includes('TRANSLATION_LEAD')&& !this.props.role.includes('PROFESSIONAL_SERVICE')
                  && !this.props.role.includes('DATA_ENGINEER'))
                  ||(this.props.role.includes('TRANSLATION_LEAD')&& (this.state.customer=="" || this.state.customer==null ))}
                // <button
                  className="button"
                  style={{ marginRight: '11PX' }}
                  type="button"
                  //onClick={this.props.gotoDatafactorycreation}
                >
                  <FormattedMessage
                    id="data.factory.create"
                    defaultMessage="Create"
                  />
                </button>
                </Link>
                
                  <Link style={(this.state.dfid == "" || 
                  (this.props.role.includes('PROFESSIONAL_SERVICE') && !this.props.username ==this.state.owner)
                  || (!this.props.role.includes('PROFESSIONAL_SERVICE')&& !this.props.role.includes('TRANSLATION_LEAD')
                   &&  !this.props.role.includes('DATA_ENGINEER')))?{ pointerEvents: 'none' }:{}}
                  to={(this.state.dfid == "" || 
                  (this.props.role.includes('PROFESSIONAL_SERVICE') && !this.props.username ==this.state.owner)
                  || (!this.props.role.includes('PROFESSIONAL_SERVICE')&& !this.props.role.includes('TRANSLATION_LEAD')
                   &&  !this.props.role.includes('DATA_ENGINEER')))?`#`:`/en-CA/createdatafactoryupdate/${this.state.dfid}/${this.state.customer}`} > 
                {/* <Link to="/en-CA/createdatafactory/dfa1">  */}
                <button    disabled={this.state.dfid == "" || 
                  (this.props.role.includes('PROFESSIONAL_SERVICE') && !this.props.username ==this.state.owner)
                  || (!this.props.role.includes('PROFESSIONAL_SERVICE')&& !this.props.role.includes('TRANSLATION_LEAD') &&  !this.props.role.includes('DATA_ENGINEER')) }
                  className="button"
                  style={{ marginRight: '11PX' }}
                  type="button"
                 // onClick={this.props.gotoDatafactorycreation2}
                >
                  <FormattedMessage
                    id="data.factory.update"
                    defaultMessage="Update"
                  />
                </button>
                </Link>
               
                <Link style={(this.state.dfid == "" ||                                     
                                    (this.props.role.includes('PROFESSIONAL_SERVICE') && this.props.username !==this.state.owner)||
                                    (!this.props.role.includes('PROFESSIONAL_SERVICE')
                                    && !this.props.role.includes('TRANSLATION_LEAD')))?{ pointerEvents: 'none' }:{}}
                
                to={(this.state.dfid == "" ||                                     
                                    (this.props.role.includes('PROFESSIONAL_SERVICE') && this.props.username !==this.state.owner)||
                                    (!this.props.role.includes('PROFESSIONAL_SERVICE')
                                    && !this.props.role.includes('TRANSLATION_LEAD')))?`#`:               
                  `/en-CA/managementDFuser/${this.state.dfid}/${this.state.customer}/${this.state.owner}`} >
                <button    disabled={this.state.dfid == "" ||                                     
                                    (this.props.role.includes('PROFESSIONAL_SERVICE') && this.props.username !==this.state.owner)||
                                    (!this.props.role.includes('PROFESSIONAL_SERVICE')&& !this.props.role.includes('TRANSLATION_LEAD'))
                                  }
                  className="button"
                  style={{ marginRight: '11PX' }}
                  type="button"
                 //  onClick={this.props.gotoManagementDFuser}
                 // disabled={this.state.delUser === "" || this.state.status === "DELETED"}
                >
                  <FormattedMessage
                    id="projects.project.manageusers"
                    defaultMessage="Manage Users"
                  />
                </button>
                </Link>
                {/* <Link to={`/en-CA/managementDDL/${this.state.dfid}/`} > */}
                <Link  style={(this.state.dfid == "")?{ pointerEvents: 'none' }:{}}
                
                to={(this.state.dfid == "")?`#`:`/en-CA/managementDDL/${this.state.dfid}/${this.state.reponame}/${this.state.customer}/${this.state.selectedjdbclength}`} >
                <button    
                disabled={this.state.dfid == "" }
                  className="button"
                  style={{ marginRight: '11PX' }}
                  type="button"
                 // onClick={this.props.gotoManagementDDL}
                 // onClick={()=>this.props.reactiveUser(this.state.delUser,this.state.delEmail,this.props.username,this.props,this.selectItem)}
                //  disabled={this.state.delUser === "" || this.state.status !== "DELETED"}
                >
                  <FormattedMessage
                    id="management.ddlfiles"
                    defaultMessage="manage DDL Files"
                  />
                </button>
                </Link>
                {/* <Link to={`/en-CA/projectmanagement/${this.state.reponame}/${this.state.dfid}/${this.state.customer}/${this.state.companyname}`}> */}
                <Link style={(this.state.dfid == "" || this.state.customer== "")?{ pointerEvents: 'none' }:{}}
                to={(this.state.dfid == "" || this.state.customer== "")?`#`:{
                  pathname: `/en-CA/projectmanagement/${this.state.reponame}/${this.state.dfid}`,
                  state:[{
                    dataFactory : this.state.reponame,
                    dataFactoryId : this.state.dfid,
                    companyname : this.state.companyname,
                    customer : this.state.customer
                  }]
                }}>
                <button
                  className="button"    disabled={this.state.dfid == "" || this.state.customer== "" || this.state.disablepr}
                  style={{ marginRight: '11PX' }}
                  type="button"
                  onClick={()=>sessionStorage.setItem('firstimeselectedcus',this.state.customer)}
                 // onClick={()=>this.props.reactiveUser(this.state.delUser,this.state.delEmail,this.props.username,this.props,this.selectItem)}
                //  disabled={this.state.delUser === "" || this.state.status !== "DELETED"}
                >
                  <FormattedMessage
                    id="management.manageprojects"
                    defaultMessage="manage projects"
                  />
                </button>
                </Link>
              </div>
            </div>
          )}
        </div>
        <Footer />
      </div>
    );
  }
}

Datafactorymanagement.propTypes = {
  username: PropTypes.string,
  usersList: PropTypes.array
};

export default injectIntl(Datafactorymanagement);



// WEBPACK FOOTER //
// ./src/components/views/Datafactorymanagement/index.js